export const ONBOARDING_URL = "https://app.swapstamp.com/hub/onboarding?source=northwestwind";

export const swapstampLanguages = ["it", "en", "es"];

export const swapstampVerticals = {
	coffeshop: {
		label: {
			it: "Coffee shop",
			en: "Coffee shops",
			es: "Cafeterias",
		},
		audience: {
			it: "bar, caffetterie e bakery",
			en: "cafes, coffee shops and bakeries",
			es: "cafeterias, bares y panaderias",
		},
		videos: {
			givePoint: "/videos/NORTHWESTWIND_Swapstamp_1.mp4",
			feedback: "/videos/NORTWESTWIND_Swapstamp2.mp4",
		},
		copy: {
			it: {
				seoTitle: "Digital loyalty card per coffee shop",
				seoDescription:
					"Swapstamp crea carte fedelta digitali per coffee shop salvabili in Apple Wallet e Google Wallet, senza app cliente, tessere cartacee o setup complesso.",
				kicker: "Apple Wallet e Google Wallet per coffee shop",
				h1: "Carte fedelta digitali per coffee shop, senza app da scaricare.",
				lead:
					"Trasforma clienti occasionali in clienti abituali con una card che resta nel loro telefono. Il cliente la salva in Apple Wallet o Google Wallet, la mostra alla cassa e tu la scansioni per assegnare punti o premi.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Pensato per colazioni, caffe, bakery e clienti che passano spesso ma dimenticano le tessere cartacee.",
				giveTitle: "Assegna punti in pochi secondi",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Tieni il tuo coffee shop nel telefono dei clienti.",
				outcomes: [
					"Nessuna app cliente: la card vive in Apple Wallet e Google Wallet.",
					"Alla cassa il cliente mostra la card, lo staff scansiona e i punti si aggiornano.",
					"Premi caffe, colazioni e acquisti ricorrenti senza stampare nuove tessere.",
					"Dashboard leggera per vedere clienti, punti, premi e opportunita di riattivazione.",
				],
				stepsTitle: "Dal banco al primo punto digitale",
				steps: ["Il cliente aggiunge la card al Wallet", "La mostra alla cassa", "Tu scansioni il QR", "I punti si aggiornano subito"],
				walletTitle: "La card resta nel telefono anche dopo l'acquisto.",
				walletText:
					"Una carta Wallet non e solo una tessera digitale: e una presenza persistente del tuo coffee shop sul telefono del cliente, pronta per punti, premi e future campagne di riattivazione.",
				fitTitle: "Per bar, bakery e coffee shop",
				fitText:
					"Swapstamp e pensato per piccoli business locali: setup rapido, costi bassi, nessun hardware complicato e nessun programma enterprise da gestire.",
				faqs: [
					["Il cliente deve scaricare un'app?", "No. Il cliente salva la card in Apple Wallet o Google Wallet e la usa dal telefono."],
					["Serve hardware dedicato?", "No. Il flusso e basato su QR e scansione alla cassa."],
					["Posso usare punti e premi?", "Si. Puoi configurare soglie, premi e progressi digitali."],
				],
				finalTitle: "Apri il tuo programma fedelta oggi.",
				finalText: "Parti con 2 settimane gratis. Poi da 9.99 al mese, con setup guidato e una card digitale pronta per i primi clienti.",
			},
			en: {
				seoTitle: "Digital loyalty card for coffee shops",
				seoDescription:
					"Swapstamp helps coffee shops launch Apple Wallet and Google Wallet loyalty cards with no customer app download, no paper cards and fast setup.",
				kicker: "Apple Wallet and Google Wallet for coffee shops",
				h1: "Digital loyalty cards for coffee shops, without another app.",
				lead:
					"Turn occasional customers into regulars with a loyalty card they save directly to Apple Wallet or Google Wallet. They show it at checkout, you scan it, and their points update instantly.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Built for coffee, breakfast, bakeries and customers who should never lose another paper card.",
				giveTitle: "Give points in seconds",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Keep your coffee shop on the customer's phone.",
				outcomes: [
					"No customer app download: the card lives in Apple Wallet and Google Wallet.",
					"At checkout the customer shows the card, staff scans it and points update.",
					"Reward coffees, breakfasts and recurring purchases without printed cards.",
					"Light dashboard for customers, points, rewards and reactivation opportunities.",
				],
				stepsTitle: "From checkout to repeat visit",
				steps: ["Customer adds the card to Wallet", "Shows it at checkout", "You scan the QR", "Points update instantly"],
				walletTitle: "The card stays on the customer's phone after they leave.",
				walletText:
					"A Wallet card is not just a paper-card replacement. It gives your coffee shop a persistent place on the customer's phone for points, rewards and future reactivation.",
				fitTitle: "For cafes, bakeries and coffee shops",
				fitText:
					"Swapstamp is designed for small local businesses: quick setup, low cost, no complicated hardware and no enterprise loyalty platform to manage.",
				faqs: [
					["Does the customer need to download an app?", "No. Customers save the card to Apple Wallet or Google Wallet and use it from their phone."],
					["Do I need dedicated hardware?", "No. The flow is based on QR cards and checkout scanning."],
					["Can I run points and rewards?", "Yes. You can configure thresholds, rewards and digital progress."],
				],
				finalTitle: "Launch your loyalty program today.",
				finalText: "Start with a 2-week free trial. Then from 9.99 per month, with guided setup and a digital card ready for your first customers.",
			},
			es: {
				seoTitle: "Tarjeta de fidelizacion digital para cafeterias",
				seoDescription:
					"Swapstamp crea tarjetas de fidelizacion para cafeterias guardadas en Apple Wallet y Google Wallet, sin app del cliente ni tarjetas de papel.",
				kicker: "Apple Wallet y Google Wallet para cafeterias",
				h1: "Tarjetas digitales para cafeterias, sin descargar otra app.",
				lead:
					"Convierte clientes ocasionales en habituales con una tarjeta que guardan en Apple Wallet o Google Wallet. La muestran en caja, tu la escaneas y los puntos se actualizan al instante.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Creado para cafe, desayunos, panaderias y clientes que no deberian perder otra tarjeta de papel.",
				giveTitle: "Da puntos en segundos",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Mantén tu cafeteria en el telefono del cliente.",
				outcomes: [
					"Sin app del cliente: la tarjeta vive en Apple Wallet y Google Wallet.",
					"En caja el cliente muestra la tarjeta, el equipo escanea y los puntos se actualizan.",
					"Premia cafes, desayunos y compras frecuentes sin imprimir tarjetas.",
					"Dashboard ligero para clientes, puntos, premios y oportunidades de reactivacion.",
				],
				stepsTitle: "De la caja a la siguiente visita",
				steps: ["El cliente anade la tarjeta al Wallet", "La muestra en caja", "Tu escaneas el QR", "Los puntos se actualizan al instante"],
				walletTitle: "La tarjeta sigue en el telefono cuando el cliente se va.",
				walletText:
					"Una tarjeta Wallet no solo reemplaza al papel. Mantiene tu cafeteria presente en el telefono del cliente para puntos, premios y futuras acciones de reactivacion.",
				fitTitle: "Para cafeterias, bares y panaderias",
				fitText:
					"Swapstamp esta pensado para pequenos negocios locales: setup rapido, bajo coste, sin hardware complicado y sin plataforma enterprise que gestionar.",
				faqs: [
					["El cliente debe descargar una app?", "No. Guarda la tarjeta en Apple Wallet o Google Wallet y la usa desde el movil."],
					["Necesito hardware dedicado?", "No. El flujo usa tarjetas QR y escaneo en caja."],
					["Puedo usar puntos y recompensas?", "Si. Puedes configurar niveles, premios y progreso digital."],
				],
				finalTitle: "Lanza tu programa de fidelizacion hoy.",
				finalText: "Empieza con 2 semanas gratis. Despues desde 9.99 al mes, con setup guiado y una tarjeta digital lista para tus primeros clientes.",
			},
		},
	},
	barber: {
		label: {
			it: "Barber",
			en: "Barbershops",
			es: "Barberias",
		},
		audience: {
			it: "barber shop e saloni uomo",
			en: "barbershops and men's salons",
			es: "barberias y salones masculinos",
		},
		videos: {
			givePoint: "/videos/barber-give-point.mp4",
			feedback: "/videos/barber-feedback.mp4",
		},
		copy: {
			it: {
				seoTitle: "Digital loyalty card per barber shop",
				seoDescription:
					"Swapstamp crea carte fedelta digitali per barber shop in Apple Wallet e Google Wallet, senza app cliente, tessere cartacee o setup complesso.",
				kicker: "Apple Wallet e Google Wallet per barber shop",
				h1: "Carte fedelta digitali per barber shop, senza app da scaricare.",
				lead:
					"Fai tornare i clienti per taglio e barba con una card che salvano in Apple Wallet o Google Wallet. La mostrano dopo il servizio, tu la scansioni e assegni punti o premi.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Pensato per tagli, barba, appuntamenti ricorrenti e clienti che vuoi riportare in agenda.",
				giveTitle: "Assegna punti dopo il servizio",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Dai ai clienti un motivo semplice per prenotare di nuovo.",
				outcomes: ["Nessuna app cliente: la card resta in Apple Wallet e Google Wallet.", "Dopo il servizio il cliente mostra la card, lo staff scansiona e i punti si aggiornano.", "Premia tagli ricorrenti, barba e servizi completati senza tessere cartacee.", "Usa dati e CRM leggero per capire chi torna e chi va riattivato."],
				stepsTitle: "Dal servizio alla prossima prenotazione",
				steps: ["Il cliente aggiunge la card al Wallet", "La mostra dopo il servizio", "Tu scansioni il QR", "I punti si aggiornano subito"],
				walletTitle: "Il tuo barber shop resta nel telefono del cliente.",
				walletText:
					"La card Wallet non sostituisce solo una tessera: mantiene il tuo salone visibile dopo il taglio e rende piu naturale tornare per il prossimo appuntamento.",
				fitTitle: "Per barber shop e saloni uomo",
				fitText:
					"Swapstamp e costruito per piccoli saloni: setup rapido, flusso semplice alla cassa, costo basso e nessun gestionale enterprise da imparare.",
				faqs: [
					["Il cliente deve scaricare un'app?", "No. Salva la card in Apple Wallet o Google Wallet e la mostra dal telefono."],
					["Serve cambiare il gestionale?", "No. Swapstamp vive sopra il flusso di cassa e appuntamento esistente."],
					["Posso premiare servizi diversi?", "Si. Puoi impostare punti e premi per tagli, barba o servizi ricorrenti."],
				],
				finalTitle: "Porta la loyalty dentro il tuo salone.",
				finalText: "Parti con 2 settimane gratis. Poi da 9.99 al mese, con una card Wallet pronta da usare in negozio.",
			},
			en: {
				seoTitle: "Digital loyalty card for barbershops",
				seoDescription:
					"Swapstamp helps barbershops launch Apple Wallet and Google Wallet loyalty cards with no customer app download, no paper cards and fast setup.",
				kicker: "Apple Wallet and Google Wallet for barbershops",
				h1: "Digital loyalty cards for barbershops, without another app.",
				lead:
					"Bring clients back for haircuts and beard trims with a card they save to Apple Wallet or Google Wallet. They show it after the service, you scan it, and points update instantly.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Built for haircuts, beard trims, repeat appointments and clients you want back in the chair.",
				giveTitle: "Give points after the service",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Give clients a simple reason to book again.",
				outcomes: ["No customer app download: the card stays in Apple Wallet and Google Wallet.", "After the service the client shows the card, staff scans it and points update.", "Reward repeat cuts, beard trims and completed services without paper cards.", "Use light CRM and loyalty data to see who returns and who should be reactivated."],
				stepsTitle: "From service to next booking",
				steps: ["Client adds the card to Wallet", "Shows it after the service", "You scan the QR", "Points update instantly"],
				walletTitle: "Your barbershop stays on the client's phone.",
				walletText:
					"The Wallet card is more than a paper-card replacement. It keeps your shop visible after the haircut and makes the next appointment easier to trigger.",
				fitTitle: "For barbershops and men's salons",
				fitText:
					"Swapstamp is built for small shops: fast setup, simple checkout flow, low cost and no enterprise loyalty system to learn.",
				faqs: [
					["Does the client need to download an app?", "No. They save the card to Apple Wallet or Google Wallet and show it from their phone."],
					["Do I need to change my booking system?", "No. Swapstamp sits on top of your existing checkout and appointment flow."],
					["Can I reward different services?", "Yes. You can set points and rewards for cuts, beard trims or recurring services."],
				],
				finalTitle: "Bring loyalty into your shop.",
				finalText: "Start with a 2-week free trial. Then from 9.99 per month, with a Wallet card ready to use in your shop.",
			},
			es: {
				seoTitle: "Tarjeta de fidelizacion digital para barberias",
				seoDescription:
					"Swapstamp crea tarjetas de fidelizacion para barberias en Apple Wallet y Google Wallet, sin app del cliente ni tarjetas de papel.",
				kicker: "Apple Wallet y Google Wallet para barberias",
				h1: "Tarjetas digitales para barberias, sin descargar otra app.",
				lead:
					"Haz que los clientes vuelvan para corte y barba con una tarjeta que guardan en Apple Wallet o Google Wallet. La muestran despues del servicio, tu la escaneas y los puntos se actualizan.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Creado para cortes, barba, citas recurrentes y clientes que quieres volver a ver.",
				giveTitle: "Da puntos despues del servicio",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Da a los clientes una razon simple para reservar otra vez.",
				outcomes: ["Sin app del cliente: la tarjeta queda en Apple Wallet y Google Wallet.", "Despues del servicio el cliente muestra la tarjeta, el equipo escanea y los puntos se actualizan.", "Premia cortes, barba y servicios recurrentes sin tarjetas de papel.", "Usa datos y CRM ligero para ver quien vuelve y quien conviene reactivar."],
				stepsTitle: "Del servicio a la siguiente reserva",
				steps: ["El cliente anade la tarjeta al Wallet", "La muestra despues del servicio", "Tu escaneas el QR", "Los puntos se actualizan al instante"],
				walletTitle: "Tu barberia queda en el telefono del cliente.",
				walletText:
					"La tarjeta Wallet no solo reemplaza al papel. Mantiene tu barberia visible despues del corte y facilita la proxima reserva.",
				fitTitle: "Para barberias y salones masculinos",
				fitText:
					"Swapstamp esta creado para pequenos salones: setup rapido, flujo simple en caja, bajo coste y sin plataforma enterprise que aprender.",
				faqs: [
					["El cliente debe descargar una app?", "No. Guarda la tarjeta en Apple Wallet o Google Wallet y la muestra desde el movil."],
					["Debo cambiar mi sistema de reservas?", "No. Swapstamp funciona sobre tu flujo actual de caja y citas."],
					["Puedo premiar servicios distintos?", "Si. Puedes configurar puntos y premios para cortes, barba o servicios recurrentes."],
				],
				finalTitle: "Lleva la fidelizacion a tu barberia.",
				finalText: "Empieza con 2 semanas gratis. Despues desde 9.99 al mes, con una tarjeta Wallet lista para tu negocio.",
			},
		},
	},
	icecream: {
		label: {
			it: "Gelateria",
			en: "Ice cream shops",
			es: "Heladerias",
		},
		audience: {
			it: "gelaterie e dessert shop",
			en: "ice cream and dessert shops",
			es: "heladerias y tiendas de postres",
		},
		videos: {
			givePoint: "/videos/icecream-give-point.mp4",
			feedback: "/videos/icecream-feedback.mp4",
		},
		copy: {
			it: {
				seoTitle: "Digital loyalty card per gelaterie",
				seoDescription:
					"Swapstamp crea carte fedelta digitali per gelaterie salvabili in Apple Wallet e Google Wallet, senza app cliente, tessere cartacee o hardware complicato.",
				kicker: "Apple Wallet e Google Wallet per gelaterie",
				h1: "Carte fedelta digitali per gelaterie, senza app da scaricare.",
				lead:
					"Trasforma clienti occasionali in clienti abituali con una card che salvano in Apple Wallet o Google Wallet. Niente app da scaricare, niente tessere cartacee: il cliente la mostra alla cassa e tu la scansioni per dare punti o premi.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Pensato per coni, coppette, vaschette, clienti stagionali e ritorni durante tutta la settimana.",
				giveTitle: "Assegna punti alla cassa",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Premia il sesto gelato e resta nel telefono del cliente.",
				outcomes: ["Nessuna app cliente: la card vive in Apple Wallet e Google Wallet.", "Alla cassa il cliente mostra la card, lo staff scansiona e i punti si aggiornano.", "Premia coni, coppette e vaschette senza rallentare la fila.", "CRM leggero per capire chi torna, chi riscatta e chi puoi riattivare."],
				stepsTitle: "Dal gelato alla prossima visita",
				steps: ["Il cliente aggiunge la card al Wallet", "La mostra alla cassa", "Tu scansioni il QR", "I punti si aggiornano subito"],
				walletTitle: "La tua gelateria resta nel telefono anche dopo che il cliente esce.",
				walletText:
					"La Wallet card non e solo una tessera digitale. E una presenza persistente sul telefono del cliente: utile per punti, premi, ritorni stagionali e future riattivazioni.",
				fitTitle: "Per gelaterie e dessert shop",
				fitText:
					"Swapstamp e fatto per piccoli business locali: setup veloce, costo basso, nessun hardware complicato e un flusso semplice anche nei momenti di fila.",
				faqs: [
					["Il cliente deve scaricare un'app?", "No. Salva la card in Apple Wallet o Google Wallet e la usa dal telefono."],
					["Funziona quando c'e fila?", "Si. Il cliente mostra la card, lo staff scansiona e i punti si aggiornano rapidamente."],
					["Posso premiare il sesto gelato?", "Si. Puoi configurare soglie, premi e regole adatte alla tua gelateria."],
				],
				finalTitle: "Apri la tua carta fedelta digitale.",
				finalText: "Parti con 2 settimane gratis. Poi da 9.99 al mese, con una card Wallet pronta per i primi clienti.",
			},
			en: {
				seoTitle: "Digital loyalty card for ice cream shops",
				seoDescription:
					"Swapstamp helps ice cream and gelato shops launch Apple Wallet and Google Wallet loyalty cards with no app download, no paper stamp cards and fast setup.",
				kicker: "Apple Wallet and Google Wallet for ice cream shops",
				h1: "Digital loyalty cards for ice cream and gelato shops.",
				lead:
					"Turn occasional customers into regulars with a loyalty card they can save directly to Apple Wallet or Google Wallet. No app to download, no paper stamp cards and no complicated hardware. Customers show their card at checkout and you scan it to give points or rewards.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Built for cones, cups, take-home boxes, seasonal customers and repeat visits throughout the week.",
				giveTitle: "Give points at checkout",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Reward the 6th gelato and stay on the customer's phone.",
				outcomes: ["No customer app download: the card lives in Apple Wallet and Google Wallet.", "At checkout the customer shows the card, staff scans it and points update.", "Reward cups, cones and take-home boxes without slowing down the queue.", "Light CRM to see who returns, who redeems and who can be reactivated."],
				stepsTitle: "From gelato to next visit",
				steps: ["Customer adds the card to Wallet", "Shows it at checkout", "You scan the QR", "Points update instantly"],
				walletTitle: "Your shop stays on the customer's phone after they leave.",
				walletText:
					"The Wallet card is not just a digital stamp card. It is a persistent place on the customer's phone for points, rewards, seasonal repeat visits and future reactivation.",
				fitTitle: "For ice cream and dessert shops",
				fitText:
					"Swapstamp is made for small local shops: fast setup, low cost, no complicated hardware and a checkout flow simple enough for busy queues.",
				faqs: [
					["Does the customer need to download an app?", "No. They save the card to Apple Wallet or Google Wallet and use it from their phone."],
					["Does it work during busy queues?", "Yes. The customer shows the card, staff scans it and points update quickly."],
					["Can I reward the 6th gelato?", "Yes. You can configure thresholds, rewards and rules that fit your shop."],
				],
				finalTitle: "Open your digital loyalty card.",
				finalText: "Start with a 2-week free trial. Then from 9.99 per month, with a Wallet card ready for your first customers.",
			},
			es: {
				seoTitle: "Tarjeta de fidelizacion digital para heladerias",
				seoDescription:
					"Swapstamp crea tarjetas de fidelizacion para heladerias en Apple Wallet y Google Wallet, sin app del cliente, tarjetas de papel ni hardware complicado.",
				kicker: "Apple Wallet y Google Wallet para heladerias",
				h1: "Tarjetas digitales para heladerias, sin descargar otra app.",
				lead:
					"Convierte clientes ocasionales en habituales con una tarjeta que guardan en Apple Wallet o Google Wallet. Sin app, sin tarjetas de papel y sin hardware complicado: el cliente la muestra en caja y tu la escaneas para dar puntos o premios.",
				primaryCta: "Try it now",
				secondaryCta: "Video",
				proofLine: "Creado para conos, tarrinas, cajas para llevar, clientes de temporada y visitas recurrentes.",
				giveTitle: "Da puntos en caja",
				feedbackTitle: "Easy to use",
				outcomeTitle: "Premia el sexto helado y queda en el telefono del cliente.",
				outcomes: ["Sin app del cliente: la tarjeta vive en Apple Wallet y Google Wallet.", "En caja el cliente muestra la tarjeta, el equipo escanea y los puntos se actualizan.", "Premia conos, tarrinas y cajas sin ralentizar la cola.", "CRM ligero para ver quien vuelve, quien canjea y quien puedes reactivar."],
				stepsTitle: "Del helado a la siguiente visita",
				steps: ["El cliente anade la tarjeta al Wallet", "La muestra en caja", "Tu escaneas el QR", "Los puntos se actualizan al instante"],
				walletTitle: "Tu heladeria queda en el telefono despues de la visita.",
				walletText:
					"La tarjeta Wallet no es solo una tarjeta digital. Es una presencia persistente en el telefono del cliente para puntos, premios, visitas estacionales y futuras reactivaciones.",
				fitTitle: "Para heladerias y tiendas de postres",
				fitText:
					"Swapstamp esta hecho para pequenos negocios locales: setup rapido, bajo coste, sin hardware complicado y un flujo simple incluso con cola.",
				faqs: [
					["El cliente debe descargar una app?", "No. Guarda la tarjeta en Apple Wallet o Google Wallet y la usa desde el movil."],
					["Funciona cuando hay cola?", "Si. El cliente muestra la tarjeta, el equipo escanea y los puntos se actualizan rapidamente."],
					["Puedo premiar el sexto helado?", "Si. Puedes configurar niveles, premios y reglas para tu heladeria."],
				],
				finalTitle: "Abre tu tarjeta digital.",
				finalText: "Empieza con 2 semanas gratis. Despues desde 9.99 al mes, con una tarjeta Wallet lista para tus primeros clientes.",
			},
		},
	},
};

export const normalizeSwapstampParams = (vertical, lang) => {
	const normalizedVertical = vertical === "coffeeshop" ? "coffeshop" : vertical;
	const safeVertical = swapstampVerticals[normalizedVertical] ? normalizedVertical : "coffeshop";
	const safeLang = swapstampLanguages.includes(lang) ? lang : "en";
	return { vertical: safeVertical, lang: safeLang };
};
